import { GalleryComponent } from './GalleryWidget/GalleryComponent';

interface GalleryWidgetWebshopProps {
  data: string;
}

/**
 * @description This component is displayed in the webshop as a fully functioning widget.
 * @param0 data string; The data / widgetState of the widget.
 * @returns {JSX.Element} The GalleryWidgetWebshop component
 */

export const GalleryWidgetWebshop = ({ data }: GalleryWidgetWebshopProps) => {
  if (!data || data === '{}') return <></>;

  const galleryData = JSON.parse(data);

  //@ts-ignore
  const languageCode = window.currentLanguageCode;

  return <GalleryComponent formData={galleryData} languageCode={languageCode} />;
};
